import { Router, UrlTree } from '@angular/router';
import { EProcess } from '@app/models/ebo/process/e-process';

import { EProcessType } from '@app/models/ebo/process/e-process-type.enum';
import { UserExperience } from '@app/models/ebo/shared/user-experience';

export class TaskFunctions {
  // public static toUrl(router: Router, task: ETask, ux: IUserExperience): UrlTree {
  //   switch (task.processType) {
  //     case EProcessType.TimeOff:
  //       return router.createUrlTree(['/', 'processes', 'time-off', task.eProcessId]);
  //     case EProcessType.MaintRequest:
  //       return router.createUrlTree(['/', 'processes', 'maint-request', task.eProcessId]);
  //     case EProcessType.SupplyRequest:
  //       return router.createUrlTree(['/', 'processes', 'supply-request', task.eProcessId]);
  //     case EProcessType.Onboarding:
  //       return router.createUrlTree(['/', 'processes', 'onboarding', ux?.activeEmployee.tenantID], {
  //         queryParams: { taskId: task.id }
  //       });
  //     default:
  //       break;
  //   }
  //   return null;
  // }

  public static toUrl2(router: Router, process: EProcess, ux: UserExperience): UrlTree {
    let response: UrlTree = null;
    switch (process.type) {
      case EProcessType.TimeOff:
        response = router.createUrlTree(['/', 'processes', 'time-off', process.id]);
        break;
      case EProcessType.MaintRequest:
        response = router.createUrlTree(['/', 'processes', 'maint-request', process.id]);
        break;
      case EProcessType.SupplyRequest:
        response = router.createUrlTree(['/', 'processes', 'supply-request', process.id]);
        break;
      case EProcessType.Onboarding: {
        const nextTasks = process.getNextTasks();
        for (let i = 0; i < nextTasks.length; i++) {
          const task = nextTasks[i];
          if (task.isApprovable(ux)) {
            //console.log('TaskFunctions.toUrl2 testing', task);
            response = router.createUrlTree(['/', 'processes', 'onboarding', ux?.activeEmployee.tenantID], {
              queryParams: { taskId: task.id }
            });
            break;
          }
        }
        break;
      }
      default:
        break;
    }
    return response;
  }
}
